import React from 'react';
import '../../styles/InputIcon.css';
interface PasswordInputProps {
  value: string;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
  icon?: string;
}

const InputIcon: React.FC<PasswordInputProps> = ({
  value,
  name,
  onChange,
  placeholder,
  className = '',
  icon,
}) => {
  return (
    <div className={`input-icon-container ${className}`}>
      <input
        type="text"
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="input-icon-field"
      />
      <img src={icon} alt="icon" className="input-icon-icon" />
    </div>
  );
};

export default InputIcon;
